var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGfSparkIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 362,
    height: 417,
    viewBox: "0 0 362 417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#B7E8E5",
    stroke: "#11B2A8",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M198.64 227.013l17.806 9.584c6.885 3.394 10.356 7.37 10.414 11.928.088 6.837.751 9.927-10.414 9.66-7.444-.177-60.762-.177-68.206 0-11.165.267-10.501-2.823-10.414-9.66.058-4.558 3.53-8.534 10.414-11.928l17.77-9.584 4.795-2.686a4.8 4.8 0 0 1 3.893-.357l3.857 1.313a12 12 0 0 0 8.351-.23l2.375-.956a4.8 4.8 0 0 1 3.97.174l5.388 2.742z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M182.343 226.718c5.369 0 11.059-4.42 14.658-7.779 3.823-3.567 5.391-13.838 5.391-19.412 0-10.82-8.976-19.59-20.049-19.59-11.073 0-20.05 8.77-20.05 19.59 0 5.32 1.36 15.882 4.881 19.412 3.642 3.651 9.54 7.78 15.17 7.78z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    transform: "translate(269.223 84.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.148,
    height: 40.098,
    fill: "#B7E7E4",
    stroke: "#11B3A9",
    strokeLinecap: "round",
    rx: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11B3A9",
    fillOpacity: 0.3,
    stroke: "#11B3A9",
    strokeLinecap: "round",
    d: "M35.643 8.911h17.822v4.455H35.643zM35.643 17.822h17.822v4.455H35.643z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#11B2A8"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M23.417 22.277l4.897 2.738c1.893.97 2.848 2.106 2.864 3.408.024 1.953.206 2.836-2.864 2.76-2.047-.05-16.71-.05-18.757 0-3.07.076-2.888-.807-2.864-2.76.016-1.302.97-2.438 2.864-3.408l4.887-2.738"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M18.935 22.277c1.492 0 3.072-1.263 4.072-2.223 1.062-1.019 1.498-3.954 1.498-5.546 0-3.091-2.494-5.597-5.57-5.597-3.075 0-5.569 2.506-5.569 5.597 0 1.52.378 4.538 1.356 5.546 1.011 1.043 2.65 2.223 4.213 2.223z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    d: "M36.084 30.074h16.813M5.854 6.01h5.21"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.094 191.075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.931,
    cy: 17.626,
    r: 17.626,
    fill: "#11B2A8",
    fillOpacity: 0.3,
    stroke: "#11B2A8",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11B3A9",
    d: "M17.465 28.36v-1.226c-2.3-.26-5.82-2.333-6.196-3.035a1.488 1.488 0 0 1 2.112-1.958c1.79 1.143 3.151 1.796 4.084 1.958v-5.401c-1.897-.502-3.287-1.16-4.169-1.977-.881-.817-1.322-2.028-1.322-3.633 0-1.606.508-2.92 1.524-3.94s2.338-1.578 3.967-1.67v-.586a.806.806 0 0 1 1.612 0v.613c1.848.149 4.245 1.167 4.699 2.114a1.502 1.502 0 0 1-2.077 1.966c-1.078-.59-1.952-.94-2.621-1.045v5.234h.075c1.931.501 3.35 1.179 4.257 2.033.907.853 1.36 2.092 1.36 3.716 0 1.625-.52 2.947-1.561 3.968-1.042 1.02-2.419 1.578-4.131 1.67v1.199a.806.806 0 1 1-1.612 0zm1.613-4.178c.806-.092 1.444-.352 1.914-.78.47-.426.705-.964.705-1.614 0-.65-.184-1.165-.554-1.545-.37-.38-1.058-.738-2.065-1.072v5.011zm-1.613-13.725c-.755.074-1.347.32-1.776.737-.428.418-.642.938-.642 1.56 0 .621.168 1.113.504 1.475.336.362.974.71 1.914 1.044v-4.816z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    transform: "translate(324.915 318.054)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9,
    cy: 17.822,
    fill: "#11B2A8",
    fillOpacity: 0.3,
    stroke: "#11B2A8",
    strokeLinecap: "square",
    rx: 17.602,
    ry: 17.822
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    d: "M9.898 19.74l5.77 4.486 10.234-12.81"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B7E8E5",
    stroke: "#11B2A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M20.835 318.268l-11.702 6.469 2.235-13.702-9.468-9.704 13.084-1.999 5.851-12.466 5.852 12.466 13.084 2-9.468 9.703 2.235 13.702z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeWidth: 2.4,
    transform: "translate(144.472 373.746)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B7E7E4",
    d: "M21.15 40.366c5.077-4.875 8.523-8.38 10.32-10.493a16.76 16.76 0 0 0 4.005-10.9c0-9.297-7.537-16.833-16.834-16.833S1.808 9.676 1.808 18.973c0 4.167 1.517 8.094 4.221 11.15 1.796 2.03 5.175 5.446 10.125 10.234a3.6 3.6 0 0 0 4.996.009z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.095,
    cy: 19.095,
    r: 6.226,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M247.463 339.337h21.243a7.2 7.2 0 0 1 7.2 7.2v52.43a7.2 7.2 0 0 1-7.2 7.2h-21.243a7.2 7.2 0 0 1-7.2-7.2v-52.43a7.2 7.2 0 0 1 7.2-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0FFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M240.263 348.024h35.643v49.01h-35.643z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.174 363.841)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.422,
    height: 9.65,
    x: 1.2,
    y: 8.086,
    fill: "#B7E8E5",
    rx: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.346 6.886V3.443C5.346 1.54 6.942 0 8.911 0c1.968 0 3.564 1.541 3.564 3.443v3.443M8.487 12.05v2.42M6.464 37.01h6.011"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M209.024 192.334c0 .49-.386.902-.842.902-.05 0-.101.003-.152.009-.008.001-.651.07-1.837.172-3.427.298-12.64.99-24.115.99-11.694 0-21.067-.732-24.559-1.047-.772-.068-1.178-.114-1.19-.114a1.145 1.145 0 0 0-.157-.01c-.46 0-.83-.403-.83-.902v-2.761c0-.499.37-.903.921-.903.792 0 1.432-.644 1.432-1.437 0-9.353 5.458-17.903 13.774-21.897v7.48c0 .795.642 1.438 1.432 1.438.792 0 1.432-.643 1.432-1.438V160.765c0-.49.411-.904.9-.904h6.135v11.708a.717.717 0 1 0 1.432 0V159.86h6.134c.488 0 .899.414.899.904v12.051c0 .795.64 1.438 1.432 1.438.79 0 1.432-.643 1.432-1.438v-7.253c8.164 4.083 13.33 12.371 13.33 21.67 0 .793.64 1.437 1.432 1.437h.723c.456 0 .842.413.842.903v2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7E8E5",
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M175.886 179.829c-.484.703-1.734 2.177 0 5.629 1.448 2.741 3.25 4.349 5.407 4.823 2.16-.334 4.1-1.942 5.82-4.823.61-1.77.538-3.481-.216-5.136.691-1.014 1.086-2.153 0-3.23-1.021-.982-2.1-.982-3.234 0-2.268-.177-3.769-.177-4.501 0-.487-.773-1.736-1.578-3.276-.181-.971.866-.864 1.75 0 2.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11B2A8",
    d: "M209.024 192.334c0 .49-.386.902-.842.902-.05 0-.101.003-.152.009-.008.001-.651.07-1.837.172-3.427.298-12.64.99-24.115.99-11.694 0-21.067-.732-24.559-1.047-.772-.068-1.178-.114-1.19-.114a1.145 1.145 0 0 0-.157-.01c-.46 0-.83-.403-.83-.902v-2.761c0-.499.37-.903.921-.903.792 0 1.432-.644 1.432-1.437 0-9.353 5.458-17.903 13.774-21.897v7.48c0 .795.642 1.438 1.432 1.438.792 0 1.432-.643 1.432-1.438V160.765c0-.49.411-.904.9-.904h6.135v11.708a.717.717 0 1 0 1.432 0V159.86h6.134c.488 0 .899.414.899.904v12.051c0 .795.64 1.438 1.432 1.438.79 0 1.432-.643 1.432-1.438v-7.253c8.164 4.083 13.33 12.371 13.33 21.67 0 .793.64 1.437 1.432 1.437h.723c.456 0 .842.413.842.903v2.76zm-.166-6.475c-.508-10.31-6.713-19.313-16.16-23.448v-1.646c0-2.084-1.69-3.778-3.764-3.778H182.8v-1.604a.717.717 0 1 0-1.432 0v1.604h-6.135c-2.075 0-3.764 1.694-3.764 3.778v1.443c-9.622 4.039-16.148 13.394-16.61 23.834a3.78 3.78 0 0 0-2.382 3.53v2.762c0 2.054 1.611 3.73 3.607 3.777.155.016.555.057 1.182.112 3.526.318 13.002 1.058 24.812 1.058 11.587 0 20.897-.699 24.361-1 1.004-.087 1.629-.15 1.828-.17 2.005-.046 3.621-1.723 3.621-3.777v-2.761c0-1.848-1.308-3.39-3.03-3.714z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M43.494 175.482a54.772 54.772 0 0 1-22.208-43.02l-.066-3.477c12.527-4.456 19.95-8.263 22.271-11.423 2.414 3.16 9.842 6.967 22.283 11.423l-.065 3.473a54.773 54.773 0 0 1-22.215 43.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11B2A8",
    fillOpacity: 0.3,
    d: "M43.777 175.482c-.372-37.882-.373-57.188-.003-57.92 2.383 3.16 9.717 6.967 22 11.423l-.069 3.694a54.73 54.73 0 0 1-21.928 42.803z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    transform: "translate(17.494 193.303)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.188,
    height: 24.752,
    y: 19.802,
    fill: "#11B3A9",
    fillOpacity: 0.3,
    rx: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11B3A9",
    fillOpacity: 0.3,
    d: "M6.566 19.778V9.076C6.566 4.063 10.608 0 15.594 0c4.986 0 9.028 4.063 9.028 9.076v.133a2.052 2.052 0 0 1-4.104 0v-.958c0-2.734-2.204-4.95-4.924-4.95s-4.925 2.216-4.925 4.95v11.527H6.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14.496 32.744a2.477 2.477 0 0 1-1.364-2.216 2.469 2.469 0 0 1 2.462-2.476 2.469 2.469 0 0 1 2.462 2.476c0 .97-.556 1.81-1.365 2.216l1.365 6.86h-4.924l1.364-6.86z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M151.517 364.6v-16.434h17.46v-12.454M115.512 261.48h-53.64v27.635H44.226M143.658 177.71h-34.829V153.6H75.414M223.085 189.629h14.713v-23.053h4.812m5.288 0v-9.567m0-6.042h39.79v-15.926M268.57 265.958h31.34v25.738h30.559v20.076M168.977 323.757v-39.119M218.7 284.638v27.134h10.833M240.286 311.37h6.092v17.37"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.24 289.094l-9.45 9.451M147.24 298.545l-9.45-9.451"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.965 153.217l-9.452 9.452M219.965 162.669l-9.452-9.452"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M247.148 217.808h18.668v-20.05h24.69v43.103h34.323v-7.46"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.37 195.53l-9.452 9.452M109.37 204.982l-9.452-9.451"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.496 173.254l-9.451 9.451M296.496 182.705l-9.451-9.451"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.813 291.322l-9.451 9.45M289.813 300.773l-9.451-9.451"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.644 255.678l-9.452 9.452M356.644 265.13l-9.452-9.452"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.727 302.46l-9.452 9.451M73.727 311.911l-9.452-9.451"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.844 335.875l-9.452 9.452M211.844 345.327l-9.452-9.452"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.562 339.303h12.778M153.383 339.303h4.455"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.54 272.268h12.778M280.362 272.268h4.455"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.78 227.918h12.778M106.602 227.918h4.455"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.53 279.951v19.167M213.53 279.951v19.167M175.585 272.97v19.168M213.53 307.593v4.973"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.87 88.874v19.167M183.87 116.516v4.972"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.614 131.014v10.648M292.614 146.608v2.227"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.163 126.464v10.649M168.163 142.058v2.228"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.3 84.76V95.41M193.3 100.354v2.228"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.05 129.921v-10.648M194.05 114.328V112.1"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.887 147.97v-10.648M183.887 132.376v-2.227"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.25 104.508V93.859M168.25 88.914v-2.228"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.475 211.21v10.65M281.475 226.805v2.227"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.26 333.734v10.648M103.26 349.328v2.227"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.972 251.223H98.805M90.33 251.223h-4.973"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.16 171.026h-19.168M121.518 171.026h-4.973"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.665 211.125h19.167M254.307 211.125h4.973"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M139.652 227.404H126.49v-9.596h-9.88v15.594H82.962v-5.998H58.414"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    transform: "translate(17.494 347.014)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.286,
    height: 40.098,
    fill: "#FFF",
    stroke: "#11B3A9",
    rx: 4.8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B7E8E5",
    stroke: "#11B2A8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.822 27.422h2.789v6.888h-2.79zM29.822 25.289h2.789v9.022h-2.79zM41.822 21.022h2.789V34.31h-2.79zM53.822 18.889h2.789V34.31h-2.79z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#11B3A9",
    d: "M15.84 22.18c13.955-1.01 27.981-6.176 42.08-15.497M53.615 6.647l4.706-1.375-1.367 4.662"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7E8E5",
    stroke: "#11B3A9",
    d: "M28.96 40.098h15.594v6.683H28.96z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#11B3A9",
    d: "M17.822 46.782h38.927"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M145.495 269.553v8.164H116.61v25.448h-8.098m-6.954 0h-4.057v15.063h11.328v23.151m0 9.777v11.206H97.501"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#11B2A8",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    transform: "translate(124.745 -12.698)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M27.915 38.979a30.176 30.176 0 0 0-3.565 9.676 30.087 30.087 0 0 0-.488 5.784c.023 1.869.22 3.726.583 5.549m8.995 16.185a30.32 30.32 0 0 0 5.539 4.097m7.881 3.18c2.721.671 5.49.95 8.23.857m7.487-1.203c3.42-1 6.667-2.6 9.567-4.757a30 30 0 0 0 4.695-4.34m3.431-4.801a30.191 30.191 0 0 0 3.472-9.19c.631-3.157.743-6.362.368-9.495m-1.707-7.024a30.214 30.214 0 0 0-4.413-7.926m-8.784-7.656a30.083 30.083 0 0 0-15.928-4.043 30.355 30.355 0 0 0-11.135 2.453m-4.777 2.582a30.012 30.012 0 0 0-6.669 6.037M73.797 19.963a39.342 39.342 0 0 0-12.616-4.648 39.227 39.227 0 0 0-7.541-.635c-2.436.03-4.858.286-7.234.76M25.304 27.165a39.53 39.53 0 0 0-5.341 7.222m-4.146 10.276A39.204 39.204 0 0 0 14.7 55.392m1.569 9.763a39.463 39.463 0 0 0 6.202 12.472 39.112 39.112 0 0 0 5.658 6.122m6.26 4.473a39.362 39.362 0 0 0 11.98 4.526c4.117.823 8.295.969 12.38.48m9.159-2.226A39.392 39.392 0 0 0 78.24 85.25m9.982-11.453a39.376 39.376 0 0 0 4.448-11.599c.639-3.04.908-6.117.823-9.167a39.576 39.576 0 0 0-3.2-14.518m-3.365-6.228a39.128 39.128 0 0 0-7.871-8.694"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.092,
    cy: 54.092,
    r: 22.277,
    fill: "#FFF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M54.092 42.954V65.23M65.23 54.092H42.955"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#11B3A9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M175.66 92.302v55.517M238.176 257.622h20.811v7.977h3.553"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfSparkIllustration);
export default __webpack_public_path__ + "static/media/gf-spark-illustration.636385d8bbdf36c0ab8ef8a25f64bbc2.svg";
export { ForwardRef as ReactComponent };